import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';

const StoresFilter = (props) => {
  const { storeId, storesInfo, onChange } = props;
  return (
    <div className="input">
      <select id="storeEq" defaultValue={storeId} onChange={onChange}>
        <option value=""> -- select a store -- </option>
        {storesInfo.map((storeInfo) => {
          return (
            <option
              value={storeInfo.id}
              key={storeInfo.id}
            >{`${storeInfo.name}`}</option>
          );
        })}
      </select>
    </div>
  );
};

export default StoresFilter;

StoresFilter.propTypes = {
  storesInfo: PropTypes.arrayOf(PropTypes.shape().isRequired),
  storeId: PropTypes.string,
  onChange: PropTypes.func,
};

StoresFilter.defaultProps = {
  storesInfo: null,
  storeId: '',
  onChange: noop,
};
